import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { paymentAPI } from 'redux/paymentAPI';
import { patch } from '@payer-admin-ui/components-v2/src/functions/lodashExtensions';
import type { ActionState, PaymentIdObject } from '@payer-admin-ui/components-v2/src/types/state';
import { ReleaseAuthorizationResponse } from '@payer-admin-ui/api/src/cardpayments/responses/ReleaseAuthorizationResponse';
import { showSnackbar } from 'redux/snackbar';
import i18n from 'i18next';
import { fetchPayment } from '../paymentsGlobalState';

export const releaseCardAuthorization = createAsyncThunk<ReleaseAuthorizationResponse, PaymentIdObject>(
  'payments/actions/ReleaseCardAuthorizationModal/release',
  async ({ paymentId }, { dispatch }) => {
    const result = await paymentAPI.actions.releaseAuthorization({ paymentId });
    dispatch(fetchPayment({ id: paymentId }));
    dispatch(
      showSnackbar(i18n.t('payments.actions.releaseCardPayment.success', { paymentId }), { severity: 'success' }),
    );
    return result;
  },
);

const releaseCardAuthorizationSlice = createSlice({
  name: 'payments/actions/ReleaseCardAuthorizationModal',
  initialState: {} as ActionState,
  reducers: {
    reset: (state, { payload: { paymentId } }: PayloadAction<PaymentIdObject>) => {
      delete state[paymentId];
    },
  },
  extraReducers: builder => {
    builder.addCase(releaseCardAuthorization.pending, (state, { meta: { arg } }) => {
      patch(state, {
        [arg.paymentId]: { isFetching: true, success: undefined, error: undefined },
      });
    });
    builder.addCase(releaseCardAuthorization.fulfilled, (state, { meta: { arg } }) => {
      patch(state, {
        [arg.paymentId]: { isFetching: false, success: true, error: undefined },
      });
    });
    builder.addCase(releaseCardAuthorization.rejected, (state, { meta: { arg }, error }) => {
      patch(state, {
        [arg.paymentId]: { isFetching: false, success: false, error },
      });
    });
  },
});

export const {
  actions: { reset },
  reducer: releaseCardAuthorizationModalReducer,
} = releaseCardAuthorizationSlice;
